import React from 'react';
import {Link} from 'react-router-dom';
import {Flex} from '@components';
import {Form, Input, Checkbox, Row, Col, Upload, Button,message} from 'antd';
import TitleTop from '@pages/Assembly/titleTop';
import NHFetch from "@utils/NHFetch";
import NextButton from '@pages/SelfHelp/common/nextIndex'
import {NHConfirm} from "@components/common/NHModal";
const {TextArea} = Input;
const basicUrl = "/zzbd";

const shztList = {
    '-1':'审核不通过',
    '0':'未审核',
    '1':'审核通过',
    '2':'已办理',
    '9':'驳回'
}
export default class View extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dkyhmc:'',
            nextUrl:this.props.nextUrl,
            search:this.props.search,
        };
    }

    componentDidMount() {
    }


    getQueryString =(name)=> {
        return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[, ''])[1].replace(/\+/g, '%20')) || null
    }

    cancel=(sqid,shzt)=>{

        if(shzt!=='0'){
            message.warning('该申请已经审核，不能取消')
            return ;
        }

        let params = {
            pkid:sqid
        }

        NHFetch("/jxcm/sfjf/deleteByParams", "POST", params)
            .then(res => {
                if (res && res.data && res.data>0) {
                    message.success("取消成功");
                    this.props.getStuPayStatusInfo();
                    this.props.reloadMenu();
                }else{
                    message.warning("取消异常");
                }
            });

    }

    // 点击文件链接或预览图标时的回调
    handlePreview = (fjmc, fjid) => {
        let isImage = true;
        if (
            !this.props.setJudge(fjmc,this.props.judgeImgList)
        ) {
            isImage = false;
        }

        if (isImage) {
            this.props.showPreview(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        } else {
            window.open(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        }
    };


    render() {
        const {data} = this.props;
        const isHide = data.axfjfqk === '1';
        console.log(data);
        return (
            <div>
                <TitleTop title="申请信息" extra={false}/>
                <div className="p-sw">
                    <div className="form_item" style={{width: '100%'}}>
                        <Row gutter={24}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>是否缴费&nbsp;: </span></Col>
                            <Col span={20}><span>{data.sfjf === '1' ? '是' : '否'}</span></Col>
                        </Row>
                        <br/>
                    </div>
                </div>
                {
                    !isHide &&
                        <div>
                            <TitleTop title="申请材料" extra={false}/>
                            <div className="p-sw">
                                <div className="form_item" style={{width: '100%' }}>
                                    <Row gutter={24}>
                                        <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                            style={{color: 'rgba(0, 0, 0, 0.85)'}}>贷款相关附件&nbsp;: </span></Col>
                                        <Col span={20}>
                                            {data['sfjffjPOs'] && data['sfjffjPOs'].map((elem, index) => {
                                                return (
                                                    <div style={{marginBottom: '20px'}}>
                                                        <a onClick={() => {
                                                            this.handlePreview(elem['fjmc'], elem['fjid']);
                                                        }}>{elem['fjmc']}</a>
                                                    </div>
                                                )
                                            })
                                            }
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            {data.shzt === '2' &&
                                <div>
                                    <TitleTop title="申请审核" extra={false}/>
                                    <div className="p-sw">
                                        <div className="form_item" style={{width: '100%', marginBottom: '24px'}}>
                                            <Row gutter={24}>
                                                <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                                    style={{color: 'rgba(0, 0, 0, 0.85)'}}>审核意见&nbsp;: </span></Col>
                                                <Col span={20}><span>{data.shyj}</span></Col>
                                            </Row>
                                        </div>
                                        <br/>
                                        <div className="form_item" style={{width: '100%', marginBottom: '24px'}}>
                                            <Row gutter={24}>
                                                <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                                    style={{color: 'rgba(0, 0, 0, 0.85)'}}>审核状态&nbsp;: </span></Col>
                                                <Col span={20}><span style={{color: '#0066FF'}}>{data.shztmc}</span></Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                }
                <div className="text-center mt-50">
                    <Button type="primary" onClick={()=>{this.cancel(data.pkid,data.shzt)}}>
                        取消
                    </Button>
                    <NextButton nextUrl={this.state.nextUrl}  search={this.state.search}/>
                </div>
            </div>
        );
    }
}
